<template>
  <div class="recaptcha-wrapper">
    <div ref="recaptcha" class="custom-recaptcha"></div>
  </div>
</template>

<script>
export default {
  name: 'RecaptchaWidget',

  data () {
    return {
      siteKey: '6LcfWgksAAAAAKZLsxTDQu4Wz_3wj5o50Peakx5F', // reCAPTCHA v2 SITE key
      widgetId: null,
      token: null,
      scriptLoaded: false
    }
  },

  mounted () {
    window.vueRecaptchaInit = () => {
      this.scriptLoaded = true
      this.renderRecaptcha()
    }

    if (window.grecaptcha && window.grecaptcha.render) {
      this.renderRecaptcha()
      return
    }

    // Se lo script NON esiste → lo carichiamo
    if (!document.getElementById('recaptcha-script')) {
      const script = document.createElement('script')
      script.id = 'recaptcha-script'
      script.src =
      'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaInit&render=explicit'
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    window.vueRecaptchaInit = () => {
      this.scriptLoaded = true
      this.renderRecaptcha()
    }
  },

  methods: {
    renderRecaptcha () {
      // Se grecaptcha NON esiste ancora → attendi che venga caricato
      if (!window.grecaptcha || !window.grecaptcha.render) {
        return this.waitForRecaptcha() // <-- chiamata alla funzione retry
      }

      // Se già renderizzato → reset
      if (this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId)
        return
      }

      // Render reCAPTCHA v2
      this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
        sitekey: this.siteKey,
        callback: this.onVerified,
        'expired-callback': this.onExpired
      })
    },
    waitForRecaptcha () {
      const check = () => {
        if (window.grecaptcha && window.grecaptcha.render) {
          this.renderRecaptcha()
        } else {
          setTimeout(check, 50) // ricontrolla ogni 50ms
        }
      }

      check()
    },

    onVerified (token) {
      this.token = token
      this.$emit('verified', token)
    },

    onExpired () {
      this.token = null
      this.$emit('expired')
    },

    getToken () {
      return this.token
    },

    isValid () {
      return !!this.token
    },

    reset () {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId)
        this.token = null
      }
    }
  }
}
</script>

<style scoped>
.recaptcha-wrapper {
  margin-top: 10px;
  margin-bottom: 15px;
  transform: scale(0.95);
  transform-origin: 0 0;
}
</style>
